import updateErrorArr from "../../../objects/CommonUse/update_error_arr";
import isNumeric from "../../../objects/CommonUse/checkIfNumeric";
import editPassword from "../../../objects/CommonUse/edit_password";

export const editPortalEntryData = (primaryRole, className, nbrPlayers, gradeLevel, username, password,
    confirmPassword, securityQuestion, securityAnswer, emailAddress, errorArr) => {
    let errorsFound = false;
    let errorMsg = "";
    if (primaryRole === "teacher"){
        if (!className || className === ""){
            errorMsg = "Required";
            updateErrorArr(8, errorMsg, errorArr);
            errorsFound = true;
        }
    }
    if (primaryRole === "teacher" || primaryRole === "parent"){
        if (nbrPlayers === ""){
            errorMsg = "Required";
            updateErrorArr(0, errorMsg, errorArr);
            errorsFound = true;
        }else{
            const validNbrPlayers = isNumeric(nbrPlayers);
            if (validNbrPlayers === false){
                errorMsg = "Must be numeric";
                updateErrorArr(0, errorMsg, errorArr);
                errorsFound = true;
            }
        }
        if (gradeLevel === "none"){
            errorMsg = "Required";
            updateErrorArr(1, errorMsg, errorArr);
            errorsFound = true;
        }
    }
    let usernameError = false;
    if (username === ""){
        errorMsg = "Cannot be blank.";
        usernameError = true;
    }else{
        if (username.includes('#')){
            errorMsg = "Cannot contain the # sign."
            usernameError = true;
        }else{
            const usernameLowerCase = username.toLowerCase();
            if (usernameLowerCase === "username" || usernameLowerCase === "password"){
                errorMsg = "Must be creative.";
                usernameError = true;
            }
        }
    }
    if (usernameError === true){
         updateErrorArr(2, errorMsg, errorArr);
         errorsFound = true;
    }
    if (password === ""){
        errorMsg = "Cannot be blank.";
        updateErrorArr(3, errorMsg, errorArr);
        errorsFound = true;
    }else{
        let passwordErrors = editPassword(password, confirmPassword);
        if (passwordErrors[0].error === true){
            errorMsg = passwordErrors[0].message;
            updateErrorArr(4, errorMsg, errorArr);
            errorsFound = true;
        }
        if (passwordErrors[1].error === true){
            errorMsg = passwordErrors[1].message;
            updateErrorArr(4, errorMsg, errorArr);
            errorsFound = true;
        }
    }
    if (securityQuestion === "none"){
        errorMsg = "Required";
        updateErrorArr(5, errorMsg, errorArr);
        errorsFound = true;
    }
    let securityAnswerError = false;
    if (!securityAnswer || securityAnswer === ""){
        errorMsg = "Required";
        securityAnswerError = true;
    }else{
        if (securityAnswer.length <= 5){
            errorMsg = "Must be at least 6 characters long.";
            securityAnswerError = true;
        }
        if (securityAnswer === "123456" || securityAnswer === "password"){
            errorMsg = "Must be something creative.";
            securityAnswerError = true;
        }
    }
    if (securityAnswerError === true){
        updateErrorArr(6, errorMsg, errorArr);
        errorsFound = true;
    }
    // no error if emailAddress is blank as it is not a required entry
    if (emailAddress && !emailAddress.includes('@')){
        errorMsg = "Must contain an '@' sign.";
        updateErrorArr(7, errorMsg, errorArr);
        errorsFound = true;
    }
    return errorsFound;
}
export default editPortalEntryData;